import React, { Component } from 'react';
import { CircularProgress } from '@material-ui/core';

class ReviewDialogContent extends Component {
	state = { loading: true };

	async componentDidMount() {
		this.setState({
			loading: false
		});
	}

	async componentWillReceiveProps(nextProps) {
		this.setState({
			loading: false
		});
	}

	render = () => {
		const { _enterpriseLocation } = this.props;
		if (this.state.loading) {
			return (
				<div className="row">
					<div className="col s12">
						<CircularProgress
							style={{ margin: 241 }}
							color="secondary"
						/>
					</div>
				</div>
			);
		}
		return (
			<div className="row">
				_enterpriseLocation: {_enterpriseLocation}
			</div>
		);
	};
}

export default ReviewDialogContent;



// WEBPACK FOOTER //
// ./src/components/settings/Modal/SettingsModalContent.js